const INITIAL_STATE = {
  data: [],
  isFetching: false,
  editSuccess: false,
  editError: false,
  removeSuccess: false,
  removeError: false,
  getAllError: false,
  errorContent: ''
};

const reducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case 'RECORD_PORTS_START_REQUEST':
      return {
        ...state,
        isFetching: true,
        addError: false,
        editError: false,
        errorContent: ''
      };
    case 'RECORD_PORTS_END_REQUEST':
      return {
        ...state,
        editSuccess: false,
        removeSuccess: false,
        isFetching: false
      };
    case 'RECORD_PORTS_GET_ALL_SUCCESS':
      return {
        ...state,
        data: payload
      };
    case 'RECORD_PORTS_GET_ALL_ERROR':
      return {
        ...state,
        getAllError: true,
        errorContent: payload
      };
    case 'RECORD_PORTS_EDIT_SUCCESS':
      return {
        ...state,
        editSuccess: true,
        editError: false
      };
    case 'RECORD_PORTS_EDIT_ERROR':
      return {
        ...state,
        editSuccess: false,
        editError: true,
        errorContent: payload
      };
    case 'RECORD_PORTS_REMOVE_SUCCESS':
      return {
        ...state,
        removeSuccess: true,
        removeError: false,
        data: state.data.filter(item => item._id !== payload)
      };
    case 'RECORD_PORTS_REMOVE_ERROR':
      return {
        ...state,
        removeSuccess: false,
        removeError: true,
        errorContent: payload
      };
    default:
      return { ...state };
  }
};

export default reducer;
